const clampIndex = (index: number, itemCount: number): number => {
  if (itemCount <= 0) {
    return -1;
  }

  return Math.min(Math.max(index, 0), itemCount - 1);
};

export const getGridNavigationTargetIndex = (
  currentIndex: number,
  key: string,
  itemCount: number,
  columns = 2,
): number => {
  const safeCurrentIndex = clampIndex(currentIndex, itemCount);
  if (safeCurrentIndex < 0) {
    return -1;
  }

  switch (key) {
    case "ArrowRight":
      return clampIndex(safeCurrentIndex + 1, itemCount);
    case "ArrowLeft":
      return clampIndex(safeCurrentIndex - 1, itemCount);
    case "ArrowDown":
      return clampIndex(safeCurrentIndex + columns, itemCount);
    case "ArrowUp":
      return clampIndex(safeCurrentIndex - columns, itemCount);
    default:
      return safeCurrentIndex;
  }
};

export const getNumericHotkeyTargetIndex = (
  key: string,
  itemCount: number,
): number | null => {
  if (!/^[1-9]$/.test(key)) {
    return null;
  }

  const targetIndex = Number(key) - 1;
  if (targetIndex < 0 || targetIndex >= itemCount) {
    return null;
  }

  return targetIndex;
};
